if( $('#pagina-ajuda').length ) {

    var vmAjuda = new Vue({
        el: '#pagina-ajuda',
        data: {
            duvidas         : {},
            palavraChave    : '',
            lightbox        : null
        },
        methods: {
            abreGif: function ( gif ) {
                this.lightbox( '/build/figs/duvidas/' + gif );
            },
            clicou: function ( duvida_numero ) {

                if( location.hash.substr(1) == duvida_numero ){
                    return this.verificaHash();
                }

                location.hash = duvida_numero;
            },
            toggle: function ( duvida_numero ) {

                var chevron = $('#chevron-' + duvida_numero);

                this.duvidas[ duvida_numero ].expandida = !this.duvidas[ duvida_numero ].expandida;

                if( this.duvidas[ duvida_numero ].expandida ){
                    chevron.css('transform', 'rotate(90deg)');
                }else{
                    chevron.css('transform', 'rotate(0deg)');
                }
            },
            verificaHash: function ( ) {

                var duvidaNum = parseInt(location.hash.substr(1));

                if( isNaN(duvidaNum) || !this.duvidas.hasOwnProperty(duvidaNum) ){
                    return;
                }

                /* Fecho todas duvidas, abro/fecho a clicada */
                for(var i in this.duvidas){

                    if( ((i != duvidaNum) && this.duvidas[i].expandida) ||
                        (i == duvidaNum) ){

                        this.toggle(i);
                    }
                }
            }
        },
        created: function () {

            this.lightbox = lity();

            var self = this;

            ajaxGET(
                '/duvidas/carregar',
                {},
                function (duvidas) {
                    Vue.set(vmAjuda, 'duvidas', duvidas);
                    Vue.nextTick(self.verificaHash);
                }
            );
        }
    });


    /* SIMPLE JAVASCRIT ROUTER - BY RONI RIGONI */
    $(window).on('hashchange', function () {

        vmAjuda.verificaHash();
    });

}
